import { Mail, Send, Users } from "lucide-react";

/**
 * Stats cards on top of the admin dashboard:
 * - total subscribers
 * - total broadcasts sent
 * - latest 3 subscribers
 */
const AdminStats = ({ stats }) => (
  <div className="grid sm:grid-cols-3 gap-4 mt-10">
    <div className="bg-white rounded-2xl p-6 border border-sand/50">
      <Users size={18} className="text-terracotta mb-3" />
      <p className="text-[10px] tracking-[0.28em] uppercase text-charcoal/60 mb-1">Suscriptoras</p>
      <p className="font-serif text-4xl text-charcoal" data-testid="stat-subscribers">
        {stats?.subscribers_total ?? 0}
      </p>
    </div>
    <div className="bg-white rounded-2xl p-6 border border-sand/50">
      <Send size={18} className="text-terracotta mb-3" />
      <p className="text-[10px] tracking-[0.28em] uppercase text-charcoal/60 mb-1">Envíos hechos</p>
      <p className="font-serif text-4xl text-charcoal" data-testid="stat-broadcasts">
        {stats?.broadcasts_sent ?? 0}
      </p>
    </div>
    <div className="bg-white rounded-2xl p-6 border border-sand/50">
      <Mail size={18} className="text-terracotta mb-3" />
      <p className="text-[10px] tracking-[0.28em] uppercase text-charcoal/60 mb-1">Últimas inscritas</p>
      <ul className="text-xs text-charcoal/70 space-y-1 mt-2">
        {(stats?.recent_subscribers || []).slice(0, 3).map((s) => (
          <li key={s.email} className="truncate">{s.email}</li>
        ))}
        {(!stats?.recent_subscribers || stats.recent_subscribers.length === 0) && (
          <li className="italic text-charcoal/40">Nadie aún</li>
        )}
      </ul>
    </div>
  </div>
);

export default AdminStats;
